"use client";
import { useState } from "react";
import { motion } from "framer-motion";
import { cn } from "../../lib/utils";

export const Tabs = ({
  tabs,
  containerClassName,
  activeTabClassName,
  tabClassName,
  contentClassName,
}) => {
  const [active, setActive] = useState(tabs[0]);
  const [hoveredIdx, setHoveredIdx] = useState(null);

  return (
    <div className={cn("w-full", containerClassName)}>
      <div className="flex flex-row items-center justify-start relative overflow-auto scrollbar-hide gap-1 border-b border-border pb-2 mb-4">
        {tabs.map((tab, idx) => (
          <button
            key={tab.value}
            onClick={() => setActive(tab)}
            onMouseEnter={() => setHoveredIdx(idx)}
            onMouseLeave={() => setHoveredIdx(null)}
            className={cn(
              "relative px-4 py-2 rounded-lg text-sm font-medium transition-colors",
              tabClassName
            )}
          >
            {hoveredIdx === idx && (
              <motion.span
                layoutId="hoverBackground"
                className="absolute inset-0 bg-muted rounded-lg"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.15 }}
              />
            )}
            {active.value === tab.value && (
              <motion.span
                layoutId="activeBackground"
                className={cn(
                  "absolute inset-0 bg-primary/20 rounded-lg",
                  activeTabClassName
                )}
                transition={{ type: "spring", bounce: 0.2, duration: 0.4 }}
              />
            )}
            <span
              className={cn(
                "relative z-10 block",
                active.value === tab.value
                  ? "text-primary"
                  : "text-muted-foreground hover:text-foreground"
              )}
            >
              <span className="flex items-center gap-2">
                {tab.icon && tab.icon}
                {tab.title}
              </span>
            </span>
          </button>
        ))}
      </div>
      <div className={cn("w-full", contentClassName)}>
        {active.content}
      </div>
    </div>
  );
};

// Simple tabs without animation for better performance
export const SimpleTabs = ({
  tabs,
  activeTab,
  onChange,
  className,
}) => {
  return (
    <div className={cn("flex gap-1 border-b border-border pb-2", className)}>
      {tabs.map((tab) => (
        <button
          key={tab.value}
          onClick={() => onChange(tab.value)}
          className={cn(
            "px-4 py-2 rounded-lg text-sm font-medium transition-colors relative",
            activeTab === tab.value
              ? "bg-primary/20 text-primary"
              : "text-muted-foreground hover:text-foreground hover:bg-muted"
          )}
        >
          <span className="flex items-center gap-2">
            {tab.icon && tab.icon}
            {tab.title}
          </span>
        </button>
      ))}
    </div>
  );
};
